import { render, staticRenderFns } from "./HowToSigfox.vue?vue&type=template&id=4da952be&scoped=true&"
import script from "./HowToSigfox.vue?vue&type=script&lang=js&"
export * from "./HowToSigfox.vue?vue&type=script&lang=js&"
import style0 from "./HowToSigfox.vue?vue&type=style&index=0&id=4da952be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da952be",
  null
  
)

export default component.exports